// Phase 2.5 — Fresh-grant create form extracted from GrantAccessModal.
// Shows the linked-to summary + email/name inputs + submit. The merchant
// MID preview is rendered inline via RelatedMidsPreview when role===merchant.

import { Btn, Input } from "@/components/Shared";
import { KeyRound } from "lucide-react";
import RelatedMidsPreview from "./RelatedMidsPreview";

export default function GrantCreateForm({
  role,
  subject,
  email, setEmail,
  name, setName,
  busy,
  relatedMids,
  relatedLoading,
  onCancel,
  onSubmit,
  formKey,
}) {
  return (
    <div className="space-y-4" key={formKey}>
      <div className="text-[12.5px] text-[var(--muted)] leading-relaxed">
        Creates a {role} account linked to{" "}
        <b className="text-[var(--ink)]">
          {role === "partner"
            ? `${subject?.partner_name} (${subject?.partner_id})`
            : subject?.merchant_name}
        </b>
        {role === "merchant" && subject?.merchant_id ? (
          <span className="text-[var(--muted)]"> · clicked from MID <code className="text-[11.5px] bg-[var(--surface-2)] px-1.5 py-0.5 rounded-sm">{subject.merchant_id}</code></span>
        ) : null}
        .
        {role === "merchant" ? (
          <span className="block mt-1.5 text-[11.5px]">A merchant entity may have multiple MIDs across PGs — the portal aggregates by name, so only <b>one</b> account is created per merchant name.</span>
        ) : null}{" "}
        We'll generate a temp password and email it to the address you enter — they'll be asked to change it on their first sign-in.
      </div>

      {role === "merchant" && (
        <RelatedMidsPreview
          loading={relatedLoading}
          data={relatedMids}
          highlightMid={subject?.merchant_id}
        />
      )}

      <div>
        <label className="text-[11px] uppercase text-[var(--muted)] font-semibold tracking-wider">Email</label>
        <Input data-testid="grant-email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="user@partner.com" />
      </div>
      <div>
        <label className="text-[11px] uppercase text-[var(--muted)] font-semibold tracking-wider">Display name <span className="text-[var(--muted)] font-normal">· optional</span></label>
        <Input
          data-testid="grant-name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder={role === "partner" ? subject?.partner_name : subject?.merchant_name}
        />
      </div>
      <div className="flex justify-end gap-2 pt-2">
        <Btn variant="ghost" onClick={onCancel} testid="grant-cancel">Cancel</Btn>
        <Btn variant="accent" onClick={onSubmit} disabled={busy} testid="grant-submit">
          <KeyRound size={13} /> {busy ? "Granting…" : "Grant access"}
        </Btn>
      </div>
    </div>
  );
}
